import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';

import { NavService } from '../../services/nav.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { langHelper } from '../../helpers-and-utilities/language-helper';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../../services/layout.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit {

  userProfile: any = { fullName: '', phoneNumber: '' };
  userID: any;
  pathToDirect: any[] = [];
  public isCollapsed = true;
  toggleClass = "fe fe-maximize";

  @ViewChild('fileInput') fileInput!: ElementRef;

  @ViewChild('quickImport', { read: TemplateRef }) quickImport: TemplateRef<any> | undefined;
  @ViewChild('requestModal', { read: TemplateRef }) requestModal: TemplateRef<any> | undefined;
  @ViewChild('request_admin', { read: TemplateRef }) request_admin: TemplateRef<any> | undefined;

  constructor(
    private layoutService: LayoutService,
    public navServices: NavService,
    private authService: AuthenticationService,
    private router: Router,
    public langHelper: langHelper,
    public translate: TranslateService) {

  }

  ngOnInit(): void {

    this.pathToDirect = (['/dashboard']);

    this.fetchUserProfile();
    console.log(this.pathToDirect);
    this.toggleSidebar();
  }

  fetchUserProfile(): void {
    // this.userModerationService.GetUser().subscribe(res => {
    //   this.userProfile = res.data;
    //   this.vendorID = this.userProfile.vendorID;
    //   console.log("USER PROFILE FIRED", this.userProfile);
    //   this.navigateBasedOnRole();  // Call navigation after user role is set
    // }, error => {
    //   console.log(error);
    // });
  }


  onFileSelected() {
    // const file: File = event.target.files[0];
    // if (file) {
    //   const formData: FormData = new FormData();
    //   formData.append('VendorID', this.vendorID);
    //   formData.append('Img', file);

    //   console.log("userIDRes: ", this.vendorID);

    //   this.vendorService.ChangeVendorImage(formData).subscribe(
    //     (res: any) => {
    //       if (res.succeeded) {
    //         this.toastService.showSuccessMessage('Image uploaded successfully!');
    //         this.fetchUserProfile(); // Refresh the user data to show the updated image
    //         this.cdr.detectChanges();
    //       } else {
    //         this.toastService.showError(res.errors.join(', '));
    //       }
    //     },
    //     (error: any) => {
    //       console.log(error);
    //       this.toastService.showError('Failed to upload image.');
    //     }
    //   );
    // }
  }

  isLoading: boolean = false;
  circleID: any;

  toggleSidebarNotification() {
    this.layoutService.emitSidebarNotifyChange(true);
  }

  toggleSidebar(): void {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
    document.body.classList.toggle('main-sidebar-hide', this.navServices.collapseSidebar);
    if (!this.navServices.collapseSidebar) {
      document.body.classList.remove('main-sidebar-open');
    }
  }

  toggleMobileSidebar(): void {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
    document.body.classList.toggle('main-sidebar-show', this.navServices.collapseSidebar);
  }

  handleChange() {
    this.isLoading = true;
  }

  ngAfterViewInit() {
    const sidebar: any = document.querySelector('.side-menu');
  }

  SignOut() {
    this.authService.logout();
    this.router.navigate(["/login"]);
  }

  viewProfile() {
    this.isCollapsed = true;
    this.router.navigate(["/profile/view-profile"]);
  }
}
